  <div class="sheet-block-title"><span translate>exercices.examen</span></div>
  <div class="startexam-wrap">
    <div class="startexam-btn" (click)="goToExamination()"><span class="difficulty-label" translate>sheet-view.pass_examination</span></div>
  </div>
  <div class="sheet-helpcopy">
    <span translate>sheet-view.help2</span>
  </div>
  <!--<div>
    <span translate>exercices.validate_sheet.text</span>
  </div>-->